import React from 'react';
import {Route, IndexRoute} from 'react-router';

import Layout from './containers/Layout';
import Home from './containers/Home';
import Category from './containers/Category';
import App from './containers/App';
import Search from './containers/Search';
import Header from './containers/Header';
import CategoriesPopup from './containers/Categories-popup';
import DeveloperApps from './containers/Developer-apps';
import PendingApps from './containers/Pending-apps';
import OpenApps from './containers/Open-apps';
import MyApps from './containers/My-apps';
import PermissionsModal from './containers/Permissions-modal';
import ProvisionModal from './containers/Provision-modal';
import Page404 from './containers/Page-404';

export default function () {
  return (
    <Route path="/" component={Layout}>
      <IndexRoute components={{children: Home, header: Header}}/>
      <Route path="/categories" components={{children: CategoriesPopup}}/>
      <Route path="/app-modal/:appSlug(/:tabUrl)" components={{children: App, header: null}} isModal/>
      <Route path="/permissions-modal/:appSlug" components={{children: PermissionsModal, header: null}} isModal/>
      <Route path="/provision-modal/:appSlug" components={{children: ProvisionModal, header: null}} isModal/>
      <Route path="/search" components={{children: Search, header: Header}}/>
      <Route path="/developer" components={{children: DeveloperApps, header: Header}}/>
      <Route path="/pending" components={{children: PendingApps, header: Header}}/>
      <Route path="/open-apps" components={{children: OpenApps, header: Header}}/>
      <Route path="/my-apps" components={{children: MyApps, header: Header}}/>
      <Route path="/:appSlug/overview" components={{children: App, header: Header}} tabUrl="overview"/>
      <Route path="/:appSlug/demo" components={{children: App, header: Header}} tabUrl="demo"/>
      <Route path="/:appSlug/features" components={{children: App, header: Header}} tabUrl="features"/>
      <Route path="/:appSlug/reviews" components={{children: App, header: Header}} tabUrl="reviews"/>
      <Route path="/:appSlug/developer" components={{children: App, header: Header}} tabUrl="developer"/>
      <Route path="/:category" components={{children: Category, header: Header}} isCategory/>
      <Route path="*" components={Page404}/>
    </Route>
  );
}



// WEBPACK FOOTER //
// ./routes.js